// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"15":"51a79d28","362":"51a79d28","366":"51a79d28","742":"865a2dd7","791":"865a2dd7","796":"865a2dd7","901":"865a2dd7"}[chunkId] + ".chunk.css";
};